import request from "./client";

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/item_groups/${id}`);
  return { data: resp.body };
};
export const getSome = async ({ q = "", limit = 10, offset = 0 }) => {
  try {
    const resp = await request.get(
      `/v1/item_groups?limit=${limit}&offset=${offset}&q=${q}`,
    );
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};
export const createOne = async ({ name }) => {
  try {
    const resp = await request.post("/v1/item_groups").send({ name });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
export const updateOne = async ({ id, name }) => {
  try {
    const resp = await request.put(`/v1/item_groups/${id}`).send({ name });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
